import ModalImageGrid from './modal-image-grid.js';

export default ModalImageGrid;
